export enum InstanceSettingsType {
  default = 'default',
  procurement = 'procurement',
  sales = 'sales',
}
